const logisticRescue = {
    'TITLE': 'Rescue Mapping',
}

export default logisticRescue;